export const mockupMenuData = {
  menu: [
    {
      id: 'vs',
      title_en: 'Virtual Servers',
      api_language_string_title: 'menuvs',
      menu_icon: 'icon-menu_virtual-servers.svg',
      default_url: '/mockup/vs/instance',
      submenu: [
        {
          title_en: 'Home',
          api_language_string_title: 'menuhome',
          hr: '0',
          count: 'null',
          url: '/mockup',
        },
        {
          title_en: 'Deploy a new VS',
          api_language_string_title: 'menuvsdeploy',
          hr: '0',
          count: 'null',
          url: '/mockup/vs/instance/create',
        },
        {
          title_en: 'Manage your VS',
          api_language_string_title: 'menuvsmanage',
          hr: '0',
          count: '14',
          url: '/mockup/vs/instance',
        },
        {
          title_en: 'VS pending to destroy',
          api_language_string_title: 'menuvsdestroypending',
          hr: '0',
          count: '0',
          url: '/mockup/vs/recoverable',
        },
        {
          title_en: `Make money with ServerPoint's affiliate program!`,
          api_language_string_title: 'menuvsaff',
          hr: '1',
          count: 'null',
          url: '/mockup/affiliate',
        },
      ],
    },
    {
      id: 'bm',
      title_en: 'Bare Metal Servers',
      api_language_string_title: 'menubm',
      menu_icon: 'icon-menu_bare-metal-servers.svg',
      default_url: '/mockup/bm/instances',
      submenu: [
        {
          title_en: 'Home',
          api_language_string_title: 'menubmhome',
          hr: '0',
          count: 'null',
          url: '/mockup',
        },
        {
          title_en: 'Deploy a new BM',
          api_language_string_title: 'menubmdeploy',
          hr: '0',
          count: 'null',
          url: '/mockup/bm/instance/create',
        },
        {
          title_en: 'Manage your BMs',
          api_language_string_title: 'menubmmanage',
          hr: '0',
          count: '1',
          url: '/mockup/bm/instances',
        },
        {
          title_en: `Make money with ServerPoint's affiliate program!`,
          api_language_string_title: 'menubmaff',
          hr: '1',
          count: 'null',
          url: '/mockup/affiliate',
        },
      ],
    },
    {
      id: 'dns',
      title_en: 'DNS Hosting',
      api_language_string_title: 'menudns',
      menu_icon: 'icon-menu_domain_dns.svg',
      default_url: '/mockup/dns/instance',
      submenu: [
        {
          title_en: 'Home',
          api_language_string_title: 'menudnshome',
          hr: '0',
          count: 'null',
          url: '/mockup',
        },
        {
          title_en: 'Manage your DNS hosting domains',
          api_language_string_title: 'menudnsmanage',
          hr: '0',
          count: '1',
          url: '/mockup/dns/instance',
        },
      ],
    },
    {
      id: 'support',
      title_en: 'Support',
      api_language_string_title: 'menusupport',
      menu_icon: 'icon-menu_support.svg',
      default_url: '/mockup/tickets',
      submenu: [
        {
          title_en: 'Home',
          api_language_string_title: 'menusupporthome',
          hr: '0',
          count: 'null',
          url: '/mockup',
        },
        {
          title_en: 'Contact our staff',
          api_language_string_title: 'menusupportcontact',
          hr: '0',
          count: 'null',
          url: '/mockup/tickets/create',
        },
        {
          title_en: 'See current tickets',
          api_language_string_title: 'menusupportmanage',
          hr: '0',
          count: '0',
          url: '/mockup/tickets',
        },
        {
          title_en: `Make money with ServerPoint's affiliate program!`,
          api_language_string_title: 'menusupportaff',
          hr: '1',
          count: 'null',
          url: '/mockup/affiliate',
        },
      ],
    },
    {
      id: 'changelog',
      title_en: 'Changelog',
      api_language_string_title: 'menuchangelog',
      menu_icon: 'icon-menu_changelog.svg',
      default_url: '/mockup/changelog',
      submenu: [
        {
          title_en: 'Home',
          api_language_string_title: 'menuchangeloghome',
          hr: '0',
          count: 'null',
          url: '/mockup/',
        },
        {
          title_en: 'Changelog',
          api_language_string_title: 'menuchangelogmanage',
          hr: '0',
          count: 'null',
          url: '/mockup/changelog',
        },
        {
          title_en: `Make money with ServerPoint's affiliate program!`,
          api_language_string_title: 'menubmchangelog',
          hr: '1',
          count: 'null',
          url: '/mockup/affiliate',
        },
      ],
    },
  ],
};

export const mockUiprofilemenu = {
  hello_en: 'Hello!',
  accountmenu: [
    {
      title_en: 'Edit Profile',
      api_language_string_title: 'toprightmenueditprofile',
      menu_icon: 'user',
      external_link: '0',
      url: '/mockup/account/profile',
    },
    {
      title_en: 'Billing',
      api_language_string_title: 'toprightmenubilling',
      menu_icon: 'credit card outline',
      external_link: '0',
      url: '/mockup/account/billing_info',
    },
    {
      title_en: 'User Management',
      api_language_string_title: 'toprightmenuusermanagement',
      menu_icon: 'users',
      external_link: '0',
      url: '/mockup/account/usermgmt',
    },
    {
      title_en: 'System Status',
      api_language_string_title: 'toprightmenusystemstatus',
      menu_icon: 'chart bar',
      external_link: '1',
      url: 'https://status.serverpoint.com/',
    },
    {
      title_en: 'Affiliate Program',
      api_language_string_title: 'toprightmenuaffiliate',
      menu_icon: 'money',
      external_link: '0',
      url: '/mockup/affiliate',
    },
    {
      title_en: 'Log out',
      api_language_string_title: 'toprightmenulogout',
      menu_icon: 'sign-out',
      external_link: '0',
      url: '/logout',
    },
  ],
};

export const mockGet2fadata = {
  primary_2fa_area_code: '',
  primary_2fa_phone: '',
  backup_2fa_area_code: '',
  backup_2fa_phone: '',
};

export const mockAreaCodeData = {
  two_fa_codes: [
    {
      id: '+1',
      country_en: 'USA, Canada and most of North America',
    },
    {
      id: '+27',
      country_en: 'South Africa',
    },
    {
      id: '+30',
      country_en: 'Greece',
    },
    {
      id: '+31',
      country_en: 'Netherlands',
    },
    {
      id: '+32',
      country_en: 'Belgium',
    },
    {
      id: '+33',
      country_en: 'France',
    },
    {
      id: '+34',
      country_en: 'Spain',
    },
    {
      id: '+39',
      country_en: 'Italy',
    },
    {
      id: '+41',
      country_en: 'Switzerland',
    },
    {
      id: '+43',
      country_en: 'Austria',
    },
    {
      id: '+44',
      country_en: 'United Kingdom',
    },
    {
      id: '+45',
      country_en: 'Denmark',
    },
    {
      id: '+46',
      country_en: 'Sweden',
    },
    {
      id: '+47',
      country_en: 'Norway',
    },
    {
      id: '+48',
      country_en: 'Poland',
    },
    {
      id: '+49',
      country_en: 'Germany',
    },
    {
      id: '+51',
      country_en: 'Peru',
    },
    {
      id: '+52',
      country_en: 'Mexico',
    },
    {
      id: '+54',
      country_en: 'Argentina',
    },
    {
      id: '+55',
      country_en: 'Brazil',
    },
    {
      id: '+56',
      country_en: 'Chile',
    },
    {
      id: '+57',
      country_en: 'Colombia',
    },
    {
      id: '+58',
      country_en: 'Venezuela',
    },
    {
      id: '+60',
      country_en: 'Malaysia',
    },
    {
      id: '+61',
      country_en: 'Australia',
    },
    {
      id: '+62',
      country_en: 'Indonesia',
    },
    {
      id: '+63',
      country_en: 'Philippines',
    },
    {
      id: '+65',
      country_en: 'Singapore',
    },
    {
      id: '+66',
      country_en: 'Thailand',
    },
    {
      id: '+81',
      country_en: 'Japan',
    },
    {
      id: '+82',
      country_en: 'South Korea',
    },
    {
      id: '+84',
      country_en: 'Vietnam',
    },
    {
      id: '+86',
      country_en: 'China',
    },
    {
      id: '+90',
      country_en: 'Turkey',
    },
    {
      id: '+91',
      country_en: 'India',
    },
    {
      id: '+94',
      country_en: 'Sri Lanka',
    },
    {
      id: '+351',
      country_en: 'Portugal',
    },
    {
      id: '+353',
      country_en: 'Ireland',
    },
    {
      id: '+354',
      country_en: 'Iceland',
    },
    {
      id: '+501',
      country_en: 'Belize',
    },
    {
      id: '+506',
      country_en: 'Costa Rica',
    },
    {
      id: '+507',
      country_en: 'Panama',
    },
    {
      id: '+509',
      country_en: 'Haiti',
    },
    {
      id: '+593',
      country_en: 'Ecuador',
    },
    {
      id: '+886',
      country_en: 'Taiwan',
    },
  ],
};

export const mockLoginAlias = {
  email_login: '',
};

export const mockEmailContact = {
  primary_email: 'lvp1138@gmail.com',
  secondary_email: 'lvp1138@gmail.com',
  primary_billing_email: 'lvp1138@gmail.com',
  secondary_billing_email: 'lvp1138@gmail.com',
};

export const mockUIConuntries = {
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  AF: 'Afghanistan',
  AX: 'Aland Islands',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AQ: 'Antarctica',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia, Plurinational State of',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CI: `C0te d'Ivoire`,
  KH: 'Cambodia',
  CM: 'Cameroon',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CD: 'Congo, the Democratic Republic of the',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curacao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FK: 'Falkland Islands (Malvinas)',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HM: 'Heard Island and McDonald Islands',
  VA: 'Holy See (Vatican City State)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran, Islamic Republic of',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KP: `Korea, Democratic People's Republic of`,
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: `Lao People's Democratic Republic`,
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia, the former Yugoslav Republic of',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia, Federated States of',
  MD: 'Moldova, Republic of',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinian Territory, Occupied',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  RE: 'Reunion',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  BL: 'Saint Barthelemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan, Province of China',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  UM: 'United States Minor Outlying Islands',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela, Bolivarian Republic of',
  VN: 'Viet Nam',
  VG: 'Virgin Islands, British',
  VI: 'Virgin Islands, U.S.',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

export const mockPersonalContact = {
  first_name: 'Peter - dsaff, adsf',
  last_name: 'SP',
  organization: 'dfgfd -fdsgs, adf ',
  address_first_line: 'Las Vegas',
  address_second_line: 'Las, NV, US - 2434',
  city: 'Las',
  state: 'NV',
  zip: 'dsafsdaf234',
  country: 'India',
  phone_primary: '2132492314',
  phone_secondary: '32324323',
  phone_emergency: '23434123421',
};

export const mockUserUiDetails = {
  portal_version: '6.2025.09.08',
  portal_release_date: '2025-09-08',
  username: 'lvp11315',
  user_level: 'primary',
  server_timedate_utc: '2025-10-16 17:46:54',
  server_timedate_pst: '2025-10-16 10:46:54',
  social_media_fb: 'https://www.facebook.com/ServerPointCom/',
  social_media_tw: 'https://twitter.com/serverpoint',
  social_media_ig: 'https://www.instagram.com/serverpoint/',
  default_url: '/welcome',
  header: '1',
  review_site: 'https://www.shopperapproved.com/reviews/serverpoint.com/',
  ticket_url: 'https://secure.serverpoint.com/tickets/index.php?/Tickets/Submit',
  homepage: 'https://www.serverpoint.com',
  privacy_policy: 'https://www.serverpoint.com/en/privacy.pdf',
  terms_of_service: 'https://www.serverpoint.com/en/tos.pdf',
  mrtg_public_fullurl: 'https://portal.serverpoint.com/#/bandwidth',
  header_messages: [
    {
      id: '3',
      color: '82bf50',
      font_color: 'FFFFFF',
      font_class: 'p',
      message: 'Our reliable line of dedicaeted servers is now available at our Dallas, Texas!',
      api_language_string: 'apiheaderannouncement3',
    },
  ],
  show_funds_deposit_section: '1',
  show_invoice_list: '1',
  show_billing_reserved_instance: '0',
  show_ip_upgrades: '0',
  show_new_vs_hours: '6',
  show_records_per_page: '20',
  blink_manage_vs_menu_seconds: '10',
  vs_label_default: 'My SSD Virtual Cloud Server',
  bm_label_default: 'My SSD Dedicated Server',
  vs_default_label: 'apiuidetailsvsdefaultlabel',
  bm_default_label: 'apiuidetailsbmdefaultlabel',
  show_reviews: '0',
  refresh_every_x_seconds: '10',
};

export const mockUserAccountDetails = {
  username: 'lvp11315',
  customer_has_vs: '14',
  customer_has_open_tickets: '0',
  customer_has_vs_pending_deletion: '0',
  customer_has_bm: '1',
  account_funds: '0.00',
  account_bucks: '9694.69',
  account_funds_plus_bucks: '9694.69',
  account_currency: 'usd',
  account_currency_symbol: '$',
  discount_vs: '0.00',
  affiliate_id: 'w1p96kyzkmmo',
  public_vs_interface_type: 'sizes',
  account_approved: '1',
  email_needs_verification: '0',
  vs_last_region_selected: 'sgp1-1',
  vs_last_os_selected: 'rockylinux.9-1.x86-64',
  vs_last_size_selected: 'g5.2',
  server_timedate_utc: '2025-10-16 17:46:54',
  server_timedate_pst: '2025-10-16 10:46:54',
  user_rights: [
    {
      profile: '1',
      profilemodify: '1',
      subuserpass: '1',
      usermanagement: '1',
      subuserloginwithemail: '1',
      affiliate: '1',
      billing: '1',
      billingviewcc: '1',
      billingaddcc: '1',
      billingdelcc: '1',
      billingdefaultcc: '1',
      billingmakepmt: '1',
      bm: '1',
      bmprovision: '1',
      bmoff: '1',
      bmon: '1',
      bmreboot: '1',
      bmdelete: '1',
      bmundodelete: '1',
      bmedittags: '1',
      bmeditrdns: '1',
      bmupdatecentral: '1',
      bmrename: '1',
      bmprice: '1',
      vs: '1',
      vsprovision: '1',
      vsoff: '1',
      vson: '1',
      vsreboot: '1',
      vschange: '1',
      vsreinstall: '1',
      vsresetpassword: '1',
      vseditrdns: '1',
      vskvm: '1',
      vsviewdeleted: '1',
      vsdelete: '1',
      vsundodelete: '1',
      vsedittags: '1',
      vsupdatecentral: '1',
      vsipadd: '1',
      vsipdelete: '1',
      vsbackupsave: '1',
      vsbackupdelete: '1',
      vsbackuprestore: '1',
      vsrename: '1',
      vsbackuprename: '1',
      vsbackupupgrade: '1',
      vsbackupdowngrade: '1',
    },
  ],
};

export const mockStoredCreditCards = {
  billing_stored_credit_cards: [
    {
      id: '73413',
      lastdigits: '1949',
      exp: '07/27',
      default: '0',
    },
  ],
};

export const mockBillingInfo = {
  billing_vs_active: '17',
  billing_bm_active: '1',
  billing_vps_active: '0',
  billing_vs_payment_amount_options: ['10', '25', '50', '100', '250', '500', '1000', '2000'],
  billing_payment_amount_options: ['10', '25', '50', '100', '250', '500', '1000', '2000'],
  default_credit_card_last_four: '',
  default_credit_card_exp: '',
  billing_due_services: '0',
  billing_due_vs_services: '0',
  billing_due_bm_services: '0',
  billing_due_vps_services: '0',
  billing_vs_monthly_cost: '307.00',
  billing_vs_hourly_cost: '0.5164',
  billing_bm_monthly_cost: '99.00',
  billing_vps_monthly_cost: '',
  billing_vps_yearly_cost: '',
  billing_vs_days_left: '877.6',
  billing_vs_due_by_hours: '0',
  billing_vs_due_negative_balance: '0',
  billing_vs_due_full_balance: '0',
  billing_bm_how_many_due: '0',
  billing_bm_how_much_due: '0',
};

export const mockVsInstance = {
  vs_instance: [
    {
      id: 'zlmZWMyMjllZjYyZmIzNDdiZTFmMTM2Z',
      label: 'My SSD Virtual Cloud  Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '0',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '1',
      backups_plan: 'backupplan1',
      last_backup_date: '2025-10-22 09:00:20',
      last_backup_hours_ago: '22',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.156',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.11',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: ['asdadad', 'helllo'],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 08:57:54',
      date_deployment_completed: '2023-08-29 10:19:23',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=a0c1e7072239a0c4',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01934523809523810000',
      price_monthly_usd: '13.00',
      price_yearly_usd: '156.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '13.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_backup_plan1',
          qty: '1',
          price_monthly_usd: '1.00',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '1',
      vs_is_suspended: '0',
    },
    {
      id: 'DgzNzAwYjgzZGJkNTFiNDEyMDY1YzczM',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-std-2k16-x64',
      loading_iso: 'DM5ZTY0MmQzNTJmOWMzZDYxNzM0M2UzN',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 2016',
      os_subname: '2016 x64',
      os_updates_available: '4',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'scl1-1',
      region_ucase: 'SCL1-1',
      region_name: 'Santa Clara, CA, US West',
      region_country: 'us',
      private_vlan: 1,
      public_ipv4_vlan: 0,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '216.108.231.151',
                  netmask: '255.255.255.0',
                  gateway: '216.108.231.1',
                  type: 'primary',
                  reverse_dns: 'santaclara-ca-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.17',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2024-02-06 08:10:38',
      date_deployment_completed: '2025-10-14 08:27:23',
      is_deployed: '1',
      kvm_url: 'https://console-scl.serverpoint.com:8090/vnc.cgi?id=41e4b6c0f6401c05',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'TIwNTU0Njg3MmQ2YjQ2OTNiNzhlMDEzY',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '1',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.155',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.10',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 08:24:38',
      date_deployment_completed: '2023-08-29 09:51:02',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=99982f8f0c9ac750',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'jFlNTQyYmFiYjczN2VkMzQwODNjYTRkN',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '0',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.151',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.4',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 08:10:19',
      date_deployment_completed: '2023-08-29 09:47:22',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=5717c57a66c37743',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'DVlMzQxMThkNmNiNGViMWY1NmZiNmRlO',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '0',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.140',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.12',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 14:04:38',
      date_deployment_completed: '2023-08-29 14:07:40',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=ae6ca303ad902945',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'DllNWY2OTNlOWJkMTYxZTI3YWE0ZTE1N',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-std-2k16-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 2016',
      os_subname: '2016 x64',
      os_updates_available: '4',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'scl1-1',
      region_ucase: 'SCL1-1',
      region_name: 'Santa Clara, CA, US West',
      region_country: 'us',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '72.18.200.50',
                  netmask: '255.255.255.0',
                  gateway: '72.18.200.1',
                  type: 'primary',
                  reverse_dns: 'santaclara-ca-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.18',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2024-04-18 08:53:07',
      date_deployment_completed: '2024-04-18 08:55:26',
      is_deployed: '1',
      kvm_url: 'https://console-scl.serverpoint.com:8090/vnc.cgi?id=77c678ce8a4b15cc',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'TBiMTVhZjE3YzIyMGRjYjY5YzdmM2ZmN',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'centos.7-4.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'centos',
      os_name: 'CentOS 7',
      os_subname: 'Latest Release 7.x x64',
      os_updates_available: '84',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'las1-1',
      region_ucase: 'LAS1-1',
      region_name: 'Las Vegas, NV, US SWest',
      region_country: 'us',
      private_vlan: 0,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '216.108.227.28',
                  netmask: '255.255.255.0',
                  gateway: '216.108.227.1',
                  type: 'primary',
                  reverse_dns: 'lasvegas-nv-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.13',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-11-08 16:10:01',
      date_deployment_completed: '2023-11-08 16:10:53',
      is_deployed: '1',
      kvm_url: 'https://console-las.serverpoint.com:8090/vnc.cgi?id=493d8695231b3ed6',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.00744047619047619000',
      price_monthly_usd: '5.00',
      price_yearly_usd: '60.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '5.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'jhlZTY5NTE4MWY3YmM3YjRiMjdjYjI0Y',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '0',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.154',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.9',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 08:21:48',
      date_deployment_completed: '2023-08-29 09:57:40',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=c76f1cf5c7e3ea75',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'TQwZjlkYTU0MDExYTgyN2E0NGQ1ZDQ0Z',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-pro-7-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 7',
      os_subname: 'Version 7 x64',
      os_updates_available: '0',
      os_updates_status: 'not_reporting',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.153',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.8',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-08-29 08:16:28',
      date_deployment_completed: '2023-08-29 09:46:23',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=ae7b5c9147c432e4',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01785714285714290000',
      price_monthly_usd: '12.00',
      price_yearly_usd: '144.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '12.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
        {
          paid_option: 'package_win',
          qty: '1',
          price_monthly_usd: '7.00',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'jQ1MWU1OWUzM2YwYjNkMzlmNGQ5MmI5N',
      label: 'My SSD Virtual Cloud Server',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'centos.7-4.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'centos',
      os_name: 'CentOS 7',
      os_subname: 'Latest Release 7.x x64',
      os_updates_available: '66',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'las1-1',
      region_ucase: 'LAS1-1',
      region_name: 'Las Vegas, NV, US SWest',
      region_country: 'us',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '216.108.227.5',
                  netmask: '255.255.255.0',
                  gateway: '216.108.227.1',
                  type: 'primary',
                  reverse_dns: 'lasvegas-nv-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.3',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-11-08 16:02:49',
      date_deployment_completed: '2023-11-08 16:03:30',
      is_deployed: '1',
      kvm_url: 'https://console-las.serverpoint.com:8090/vnc.cgi?id=a5766ed5eaf45bac',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.00744047619047619000',
      price_monthly_usd: '5.00',
      price_yearly_usd: '60.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '5.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'zNjZmUyYzk5NWNjZjk4OTY5YjM0OWFhO',
      label: 'My Virtual Cloud Server',
      size: 'g5.2',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'almalinux.10-0.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'almalinux',
      os_name: 'AlmaLinux 10',
      os_subname: 'Latest Release 10.x x64',
      os_updates_available: '9',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '2048',
      ram_gb: '2',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '100',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '3000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.185',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.15',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2025-10-20 09:34:30',
      date_deployment_completed: '2025-10-20 09:42:28',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=1c084f0bd3567de1',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01488095238095240000',
      price_monthly_usd: '10.00',
      price_yearly_usd: '120.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '10.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'jc1OTM3MjI0YmVmY2Q3OGIxYzM4NzdmZ',
      label: 'My Virtual Cloud Server-2',
      size: 'g5d.8',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'windows-std-2k16-x64',
      loading_iso: '',
      os_class: 'windows',
      os_family: 'windows',
      os_name: 'Windows 2016',
      os_subname: '2016 x64',
      os_updates_available: '1',
      os_updates_status: '',
      vcpus: '6',
      ram_mb: '8192',
      ram_gb: '8',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '2000',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '5000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.28',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.5',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2025-09-24 10:10:32',
      date_deployment_completed: '2025-09-24 11:37:42',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=1c132e211c02081b',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.23809523809523800000',
      price_monthly_usd: '160.00',
      price_yearly_usd: '1920.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '160.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'mVjZWMxMjFhZmVlZDhiOTc1MjA0NmM2N',
      label: 'My Virtual Cloud Server-3',
      size: 'g5.2',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'rockylinux.9-1.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'rockylinux',
      os_name: 'Rocky Linux 9',
      os_subname: 'Latest Release 9.x x64',
      os_updates_available: '0',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '2048',
      ram_gb: '2',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '100',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '3000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.43.38',
                  netmask: '255.255.255.0',
                  gateway: '64.235.43.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.6',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2025-09-24 11:11:40',
      date_deployment_completed: '2025-09-24 11:23:05',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=c89dab41518dd1bf',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01488095238095240000',
      price_monthly_usd: '10.00',
      price_yearly_usd: '120.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '10.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'WJhM2U3MzgzMjQ0MWFhNTRhYzZiMTQxO',
      label: 'Pedro Nieto',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'centos.7-4.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'centos',
      os_name: 'CentOS 7',
      os_subname: 'Latest Release 7.x x64',
      os_updates_available: '10',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'las1-1',
      region_ucase: 'LAS1-1',
      region_name: 'Las Vegas, NV, US SWest',
      region_country: 'us',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '216.108.229.36',
                  netmask: '255.255.255.0',
                  gateway: '216.108.229.1',
                  type: 'primary',
                  reverse_dns: 'lasvegas-nv-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.1',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-11-08 15:59:39',
      date_deployment_completed: '2023-11-08 16:00:33',
      is_deployed: '1',
      kvm_url: 'https://console-las.serverpoint.com:8090/vnc.cgi?id=dfa5cdaa97893cb2',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.00744047619047619000',
      price_monthly_usd: '5.00',
      price_yearly_usd: '60.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '5.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'zUyYzE3NmE5ZmUwY2I0NGNlZDYyYjQzY',
      label: 'Pedro Nieto',
      size: 'g3.1',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'centos.7-4.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'centos',
      os_name: 'CentOS 7',
      os_subname: 'Latest Release 7.x x64',
      os_updates_available: '8',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '1024',
      ram_gb: '1',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '35',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '2000',
      additional_bandwidth_gb_month: '',
      region: 'las1-1',
      region_ucase: 'LAS1-1',
      region_name: 'Las Vegas, NV, US SWest',
      region_country: 'us',
      private_vlan: 1,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 0,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.60.20',
                  netmask: '255.255.255.0',
                  gateway: '64.235.60.1',
                  type: 'primary',
                  reverse_dns: 'lasvegas-nv-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.2',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2023-11-08 16:00:16',
      date_deployment_completed: '2023-11-08 16:01:04',
      is_deployed: '1',
      kvm_url: 'https://console-las.serverpoint.com:8090/vnc.cgi?id=96da2e617577475e',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.00744047619047619000',
      price_monthly_usd: '5.00',
      price_yearly_usd: '60.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '5.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
    {
      id: 'TYzMWQ2ZmQyZmY2YTRiZTU3ZjEzYjU3Y',
      label: 'VM with IPv6',
      size: 'g5.2',
      status: 'running',
      virttype: 'kvm',
      app: '',
      deployed_from_saved_template_with_id: '',
      os: 'ubuntu.24-04.x86-64',
      loading_iso: '',
      os_class: 'linux',
      os_family: 'ubuntu',
      os_name: 'Ubuntu 24',
      os_subname: '24.04 LTS x64',
      os_updates_available: '123',
      os_updates_status: '',
      vcpus: '2',
      ram_mb: '2048',
      ram_gb: '2',
      retrievable_password: '',
      nic_mbps: '1000',
      disks: [
        {
          disk_id: '0',
          disk_gb: '100',
          type: 'primary',
          technology: 'distributed',
        },
      ],
      bandwidth_gb_month: '3000',
      additional_bandwidth_gb_month: '',
      region: 'sgp1-1',
      region_ucase: 'SGP1-1',
      region_name: 'Singapore',
      region_country: 'sg',
      private_vlan: 0,
      public_ipv4_vlan: 1,
      public_ipv6_vlan: 1,
      backups_is_enabled: '0',
      backups_plan: '',
      last_backup_date: '',
      last_backup_hours_ago: '',
      networks: [
        {
          eth0: [
            {
              ipv4: [
                {
                  ip: '64.235.61.160',
                  netmask: '255.255.255.0',
                  gateway: '64.235.61.1',
                  type: 'primary',
                  reverse_dns: 'singapore-datacenter.serverpoint.com',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
        {
          eth1: [
            {
              ipv4: [
                {
                  ip: '192.168.0.14',
                  netmask: '255.255.0.0',
                  route: 'private',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'private',
                },
              ],
            },
          ],
        },
        {
          eth2: [
            {
              ipv4: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
            {
              ipv6: [
                {
                  ip: '',
                  netmask: '',
                  route: 'public',
                },
              ],
            },
          ],
        },
      ],
      tags: [],
      project_id: '',
      project_name: '',
      date_deployment_ordered: '2025-10-20 09:32:25',
      date_deployment_completed: '2025-10-20 09:34:06',
      is_deployed: '1',
      kvm_url: 'https://console-sgp.serverpoint.com:8090/vnc.cgi?id=87d04b27a1b7bd06',
      can_add_ipv4_ips: '7',
      billing_schedule: 'hourly',
      price_hourly_usd: '0.01488095238095240000',
      price_monthly_usd: '10.00',
      price_yearly_usd: '120.00',
      next_payment_date: '',
      billing_due: '0',
      price_nodiscount_monthly_usd: '10.00',
      vs_cancelation_scheduled: '0',
      paid_options_included: [
        {
          paid_option: 'package_free_ipv4_ips',
          qty: '1',
          price_monthly_usd: '0',
        },
      ],
      vs_is_locked: '0',
      vs_is_suspended: '0',
    },
  ],
  meta: {
    total_all_records: '16',
    local_time_pst: '2025-10-23 07:36:28',
    utc_time: '2025-10-23 14:36:28',
    per_page: '16',
    how_many_pages: '1',
    page_number: '1',
  },
};

export const mockInvoiceData = {
  invoices: [
    {
      id: '837437',
      date: '2025-10-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '837015',
      date: '2025-10-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836943',
      date: '2025-10-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836850',
      date: '2025-10-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836795',
      date: '2025-10-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836631',
      date: '2025-10-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836485',
      date: '2025-10-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '836429',
      date: '2025-10-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835847',
      date: '2025-09-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835470',
      date: '2025-09-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835418',
      date: '2025-09-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835296',
      date: '2025-09-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835246',
      date: '2025-09-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '835087',
      date: '2025-09-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '834943',
      date: '2025-09-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '834878',
      date: '2025-09-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '834324',
      date: '2025-08-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833924',
      date: '2025-08-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833874',
      date: '2025-08-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833760',
      date: '2025-08-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833709',
      date: '2025-08-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833550',
      date: '2025-08-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833405',
      date: '2025-08-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '833337',
      date: '2025-08-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '832776',
      date: '2025-07-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '832347',
      date: '2025-07-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '832291',
      date: '2025-07-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '832176',
      date: '2025-07-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '832130',
      date: '2025-07-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '831994',
      date: '2025-07-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '831815',
      date: '2025-07-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '831739',
      date: '2025-07-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '831144',
      date: '2025-06-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830729',
      date: '2025-06-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830678',
      date: '2025-06-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830570',
      date: '2025-06-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830517',
      date: '2025-06-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830394',
      date: '2025-06-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830237',
      date: '2025-06-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '830185',
      date: '2025-06-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '829584',
      date: '2025-05-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '829144',
      date: '2025-05-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '829084',
      date: '2025-05-14',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828964',
      date: '2025-05-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828918',
      date: '2025-05-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828790',
      date: '2025-05-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828587',
      date: '2025-05-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828548',
      date: '2025-05-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '828371',
      date: '2025-05-01',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827944',
      date: '2025-04-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827530',
      date: '2025-04-15',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827486',
      date: '2025-04-14',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827460',
      date: '2025-04-14',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827341',
      date: '2025-04-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827293',
      date: '2025-04-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '827194',
      date: '2025-04-08',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '826997',
      date: '2025-04-05',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '826957',
      date: '2025-04-04',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '826714',
      date: '2025-04-01',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '826306',
      date: '2025-03-23',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '826282',
      date: '2025-03-23',
      amount: '50.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '825598',
      date: '2025-03-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '825536',
      date: '2025-03-11',
      amount: '10.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '824940',
      date: '2025-03-01',
      amount: '5.00',
      payment_type: 'paypal',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '824020',
      date: '2025-02-12',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '823964',
      date: '2025-02-11',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '823959',
      date: '2025-02-11',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
    {
      id: '823443',
      date: '2025-02-01',
      amount: '5.00',
      payment_type: 'cc',
      status: 'paid',
      service_category: 'ccloudres',
    },
  ],
};

export const mockPdfData = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<!-- 42101831145 -->
<head>
</head>
<body bgcolor="#F5F5F5">
	<div style="width: 95%;	margin: 0 20px 0 20px;">
		<div style="width: 100%;float:left;padding: 10px 20px 10px 20px;">
			<div style="width: 48%;float:left;">
				<img src="https://www.serverpoint.com/logos/serverpoint-logo1.png" style="width: 200px" alt="serverpoint logo" />
			</div>
			<div style="width: 48%;float:right;text-align: right;padding-top: 5px;line-height: 1.5em">
				<span style="font-size: 1.3em;font-style: normal;font-family: 'Trebuchet MS';color: #b54b22;">Invoice #834878</span><br />
				<span style="font-size: 0.9em;font-style: normal;font-family: 'Verdana','Helvetica','Arial';color: black">September 04, 2025</span><br />
				<span style="font-size: 0.9em;font-style: normal;font-family: 'Verdana','Helvetica','Arial';color: black">This invoice has been paid</span>
			</div>
		</div>
		<div style="width: 100%;float:left;padding: 10px 20px 10px 20px;border: 1px solid #c2c2c2;background-color: #fffefe;border-radius: 5px;" >
			<br />
			<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 1em;color: #b54b22;font-weight: bold">Invoice to</span>
			<p style="font-size: 0.9em;font-family: 'Trebuchet MS','Helvetica','Arial';padding-left: 20px">
				Username: timppaik<br />
			</p>
			<br />
			<h1 style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 1em;font-weight: bold;color: #b54b22;border-bottom:1px solid #a9a9ad">
			Your credit card, ending in 0, has been charged.<br /><br />
			</h1>
			<br />
			<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 1em;color: #b54b22;line-height: 0.8em;font-weight: bold">Service: ColossusCloud Reserved Instances</span><br /><br />
			<div style="line-height: 1.5em">
			<table style="padding: 0 0px 10px 0;width: 100%">
				<tr>
					<td style="width: 45%">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;font-weight: bold;color: #b54b22;">Virtual Machine</span>
					</td>
					<td style="width: 20%px">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;font-weight: bold;color: #b54b22;">Originally due</span>
					</td>
					<td style="width: 15%;">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;font-weight: bold;color: #b54b22;">Now due on</span>
					</td>
					<td style="width: 20%;text-align: right;">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;font-weight: bold;color: #b54b22;">Price</span>
					</td>
				</tr>
				<tr>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">6f2e9b</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">Sep 04, 2025</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">Oct 04, 2025</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid;text-align: right">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">&#36;5.00/mo</span>
					</td>
				</tr>
			</table>
			</div>
			<br />
			<div style="line-height: 1.5em">
			<table style="padding: 0 0px 10px 0;width: 100%">
				<tr>
					<td style="width: 70%">
					</td>
					<td style="width: 30%;text-align: right">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;font-weight: bold;color: #b54b22;">Total</span>
					</td>
				</tr>
				<tr>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">Invoice total</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid;text-align: right">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">&#36;5.00</span>
					</td>
				</tr>
				<tr>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">Payment from credit card *0</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid;text-align: right">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: #397a0c">(&#36;5.00)</span>
					</td>
				</tr>
				<tr>
					<td style="border-bottom: 1px #e8e6e6 solid">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">Remaining balance</span>
					</td>
					<td style="border-bottom: 1px #e8e6e6 solid;text-align: right">
						<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.8em;color: black">&#36;0.00</span>
					</td>
				</tr>
			</table>
			</div>
			<br />
		</div>
		<div style="width: 100%;float:left;padding: 10px 20px 10px 20px;line-height: 30px;border: 1px solid #c2c2c2;background-color: #fffefe;border-radius: 5px;margin-top: 10px" >
			<div style="width: 48%;float:left;">
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://www.serverpoint.com">ServerPoint.com</a> |
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://portal.serverpoint.com">Client Portal</a> |
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://www.serverpoint.com/en/blog">Blog</a> |
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://status.serverpoint.com/">Status</a>
			</div>
			<div style="width: 48%;float:right;text-align: right">
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://www.facebook.com/ServerPointCom">Facebook</a> |
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://www.instagram.com/serverpoint/">Instagram</a> |
				<a style="font-family: 'Trebuchet MS';font-size: 0.9em;font-weight: bold;color: #b54b22;text-decoration: underline;" href="https://x.com/serverpoint/">X</a>
			</div>
		</div>
		<div style="width: 100%;float:left;padding: 10px 20px 10px 20px;margin-top: 10px" >
			<span style="font-family: 'Trebuchet MS','Helvetica','Arial';font-size: 0.7em;">
			All services at ServerPoint.com are recurring and are not refundable. A+ Hosting, Inc., DBA ServerPoint.com, 10620 Southern Highlands Pkwy, Suite 110-491, Las Vegas, NV, 89141<br /><br />
			Please do not reply to this message. To contact us, please open a ticket via ServerPoint's <a href="https://portal.serverpoint.com">Client Portal</a>.
			</span>
		</div>
</div>
</body>
`;
